import React from 'react';
import { IS_PHONE, IS_TABLET } from '@config/environment';
import DialogModal from '@component/gridgio/modal/dialog-modal';
import { Navigate, Route, Routes } from 'react-router-dom';
import WorkPage from '@page/gridgio/project-page/work-page';
import ProjectItemPage from '@page/gridgio/project-page/item-page';
import PlanPage from '@page/gridgio/project-page/plan-page';
import SourceHomePage from '@page/gridgio/source-page/home-page';
import LandingPage from '@page/gridgio/landing-page';
import StartPage from '@page/gridgio/start-page';
import ProjectHomePage from '@page/gridgio/project-page/home-page';
import HomeBeginPage from '@page/gridgio/home-page/begin-page';
import LabHomePage from '@page/gridgio/lab-page/home-page';
import { GRIDGIO_PATH } from '@constant/gridgio/route-path';
import { useWebviewStatus } from '@hook/common/useApplication';
import { useTypedSelector } from '@hook/common/useStore';

const GridgioApp = () => {
  useWebviewStatus();
  const isDialogModal = useTypedSelector((state) => state.rootReducer?.gridgioModalReducer?.isDialogModal) ?? false;
  const isAuthenticated = useTypedSelector((state) => state.rootReducer?.userReducer?.isAuthenticated) ?? false;

  return (
    <>
      {isDialogModal && <DialogModal />}
      <Routes>
        <Route path='/' element={<Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />} />
        <Route
          path={GRIDGIO_PATH.LANDING_PATH}
          element={
            isAuthenticated || IS_PHONE || IS_TABLET ? (
              <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />
            ) : (
              <LandingPage />
            )
          }
        />
        <Route path={GRIDGIO_PATH.APP_PATH} element={<Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />} />
        <Route
          path={GRIDGIO_PATH.CHECKPOINT_PATH}
          element={
            isAuthenticated ? (
              <Navigate replace to={GRIDGIO_PATH.HOME_BEGIN_PATH} />
            ) : IS_PHONE || IS_TABLET ? (
              <Navigate replace to={GRIDGIO_PATH.START_PATH} />
            ) : (
              <Navigate replace to={GRIDGIO_PATH.LANDING_PATH} />
            )
          }
        />
        <Route
          path={GRIDGIO_PATH.START_PATH}
          element={isAuthenticated ? <Navigate replace to={GRIDGIO_PATH.INITIAL_SERVICE_PATH} /> : <StartPage />}
        />
        <Route
          path={GRIDGIO_PATH.HOME_BEGIN_PATH}
          element={isAuthenticated ? <HomeBeginPage /> : <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />}
        />
        <Route
          path={GRIDGIO_PATH.LAB_HOME_PATH}
          element={isAuthenticated ? <LabHomePage /> : <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />}
        />
        <Route
          path={GRIDGIO_PATH.SOURCE_HOME_PATH}
          element={isAuthenticated ? <SourceHomePage /> : <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />}
        />
        <Route
          path={GRIDGIO_PATH.PROJECT_HOME_PATH}
          element={isAuthenticated ? <ProjectHomePage /> : <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />}
        />
        <Route
          path={GRIDGIO_PATH.PROJECT_ITEM_PATH}
          element={isAuthenticated ? <ProjectItemPage /> : <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />}
        />
        <Route
          path={GRIDGIO_PATH.PROJECT_PLAN_PATH}
          element={isAuthenticated ? <PlanPage /> : <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />}
        />
        <Route
          path={GRIDGIO_PATH.PROJECT_WORK_PATH}
          element={isAuthenticated ? <WorkPage /> : <Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />}
        />
        <Route path='*' element={<Navigate replace to={GRIDGIO_PATH.CHECKPOINT_PATH} />} />
      </Routes>
    </>
  );
};

export default GridgioApp;
